import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent {
  protected refreshPage(): void {
    window.location.reload();
  }
}
